<script>
    const {
        unfinishedTasks,
        activityModel,
        navigationBar,
    } = $props()

    function gotoTask(taskGroupModel) {
        navigationBar.setActiveItem(taskGroupModel.get('sequence'))
    }
</script>

{#if unfinishedTasks.length < 11}
    <div class="missing-tasks">
        {#each unfinishedTasks as taskModel (taskModel.id)}
            {const taskGroupModel = activityModel.task_groups.get(taskModel.get('task_group_id'))}
            <button class="task-label" onclick={() => gotoTask(taskGroupModel)}>
                {taskGroupModel.get('index')}{taskModel.get('index')}
            </button>
        {/each}
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.missing-tasks {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.task-label {
  font-size: 16px;
  padding: 8px 16px;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 12px;
}
.task-label:hover {
  background: rgba(0, 0, 0, 0.25);
}</style>
